import { defineMessages } from 'react-intl';

const messages = defineMessages({
  imageGallery: {
    id: 'imageGalleryTitle',
    defaultMessage: 'Image Gallery',
  },
  columns: {
    id: 'imageGalleryColumns',
    defaultMessage: 'Columns',
  },
  gapBetweenImages: {
    id: 'imageGalleryGap',
    defaultMessage: 'Gap between images',
  },
  gapSmall: {
    id: 'imageGalleryGapSmall',
    defaultMessage: 'Small',
  },
  gapMedium: {
    id: 'imageGalleryGapMedium',
    defaultMessage: 'Medium',
  },
  gapLarge: {
    id: 'imageGalleryGapLarge',
    defaultMessage: 'Large',
  },
  gapExtraLarge: {
    id: 'imageGalleryGapExtraLarge',
    defaultMessage: 'Extra Large',
  },
  defaultSection: {
    id: 'imageGalleryDefaultSection',
    defaultMessage: 'Default',
  },
  // Lightbox fieldset
  lightboxSection: {
    id: 'imageGalleryLightboxSection',
    defaultMessage: 'Lightbox',
  },
  enableLightbox: {
    id: 'imageGalleryEnableLightbox',
    defaultMessage: 'Enable click-to-enlarge lightbox',
  },
  lightboxZoom: {
    id: 'imageGalleryLightboxZoom',
    defaultMessage: 'Enable zoom in lightbox',
  },
  lightboxFullscreen: {
    id: 'imageGalleryLightboxFullscreen',
    defaultMessage: 'Enable fullscreen button in lightbox',
  },
  lightboxCounter: {
    id: 'imageGalleryLightboxCounter',
    defaultMessage: 'Show image counter (1 / N)',
  },
});

export const ImageGallerySchema = ({ intl }) => ({
  title: intl.formatMessage(messages.imageGallery),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.defaultSection),
      fields: ['columns', 'gap'],
    },
    {
      id: 'lightbox',
      title: intl.formatMessage(messages.lightboxSection),
      fields: ['enable_lightbox', 'lightbox_zoom', 'lightbox_fullscreen', 'lightbox_counter'],
    },
  ],
  properties: {
    columns: {
      title: intl.formatMessage(messages.columns),
      type: 'integer',
      default: 3,
      minimum: 1,
      maximum: 6,
    },
    gap: {
      title: intl.formatMessage(messages.gapBetweenImages),
      type: 'string',
      default: '16px',
      choices: [
        ['8px', intl.formatMessage(messages.gapSmall)],
        ['16px', intl.formatMessage(messages.gapMedium)],
        ['24px', intl.formatMessage(messages.gapLarge)],
        ['32px', intl.formatMessage(messages.gapExtraLarge)],
      ],
    },
    enable_lightbox: {
      title: intl.formatMessage(messages.enableLightbox),
      type: 'boolean',
      default: true,
    },
    lightbox_zoom: {
      title: intl.formatMessage(messages.lightboxZoom),
      type: 'boolean',
      default: true,
    },
    lightbox_fullscreen: {
      title: intl.formatMessage(messages.lightboxFullscreen),
      type: 'boolean',
      default: true,
    },
    lightbox_counter: {
      title: intl.formatMessage(messages.lightboxCounter),
      type: 'boolean',
      default: true,
    },
  },
  required: [],
});
